import React from 'react'
import Button from '@material-ui/core/Button'

const RenewAction = ({ classes, sm, onClick }) => (
  <div className={classes[sm ? 'buttons-sm' : 'buttons']}>
    <Button
      className={classes['button-single']}
      variant="contained"
      color="primary"
      onClick={onClick}
    >
      Solicitar Renovação de Matrícula (Rematrícula)
    </Button>
  </div>
)

export default RenewAction
